<template>
  <el-container class="body-container">
    <el-main class="body-main" id="bodyMain">
      <div class="body-header">
        <!-- <el-carousel height="100px" style="width: 100%;">
          <el-carousel-item v-for="(item,index) in noticeBanner" :key="index">
            <el-image :src="item.picUrl" fit="cover" style="width: 100%;"></el-image>
          </el-carousel-item>
        </el-carousel> -->
        <el-image :src="noticeBanner[0].picUrl" fit="cover" style="width: 100%;height: 152px;"></el-image>
      </div>
      <div style="display: flex;justify-content: center;">
        <div class="body-main_center">
          <div class="body-main_one">
            <div class="list-content" style="border-radius: 12px 12px 0 0;">
              <div class="list-title">
                <div class="list-title_bold">动态新闻<span>/NEWS</span></div>
                <div class="list-title_more" @click="newList('new')">更多<i class="el-icon-arrow-right"></i></div>
              </div>
              <el-carousel height="148px" style="width: 390px;">
                <el-carousel-item v-for="(item,index) in picUrls" :key="index">
                  <el-image :src="global.BASE_URL_2971 + item.picUrl" fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
              <div class="list-body">
                <el-skeleton animated :loading="news.length > 0?false:true" :throttle="500">
                  <template>
                    <div class="list-item" v-for="(item,index) in news" :key="index" @click="newDetail(item)">
                      <div>
                        <el-tag type="primary" v-show="item.flag = 'new'">NEW</el-tag>
                        {{ item.title | filterNew }}
                      </div>
                      <div>
                        {{ changeDay(item.publishTime) }}
                      </div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
            </div>
            <div class="list-content" style="border-radius: 0 0 12px 12px;margin-bottom: 15px;">
              <div class="list-title">
                <div class="list-title_bold">通知公告<span>/NOTICES</span></div>
                <div class="list-title_more" @click="newList('notice')">更多<i class="el-icon-arrow-right"></i></div>
              </div>
              <div class="list-body" style="min-height: 130px;">
                <el-skeleton animated :loading="news.length > 0?false:true" :throttle="500">
                  <template>
                    <div class="list-item" v-for="(item,index) in notices" :key="index" @click="newDetail(item)">
                      <div>
                        <el-tag type="primary" v-show="item.flag = 'new'">NEW</el-tag>
                        {{ item.title | filterNew }}
                      </div>
                      <div>
                        {{ changeDay(item.publishTime) }}
                      </div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
            </div>
            <div class="list-content" style="border-radius: 12px;">
              <div class="list-title">
                <div class="list-title_bold">日程管理<span>/SCHEDULE</span></div>
                <div class="list-title_more" @click="newList('notice')">更多<i class="el-icon-arrow-right"></i></div>
              </div>
              <div class="list-body">
                <div class="list-item_canlendar">
                  <lunar-canlendar :double="false" @handleOne="clickOne"></lunar-canlendar>
                  <el-popover
                      placement="top-end"
                      width="320"
                      popper-class="main_right--popover"
                      v-model="popoverVisible"
                      ref="mainPopover"
                      @show="showPopover"
                      trigger="click">
                      <div v-show="form.type !== 'view'">
                        <el-radio-group style="margin-bottom: 5px;" v-model="form.scheduleType">
                          <el-radio-button label="schedule">日程</el-radio-button>
                          <el-radio-button label="meeting">会议</el-radio-button>
                        </el-radio-group>
                        <el-form :model="form" label-width="60px" size="mini" class="table-form">
                          <el-form-item label="主题" required>
                            <el-input v-model="form.title"></el-input>
                          </el-form-item>
                          <el-form-item label="内容">
                            <el-input type="textarea" :rows="3" v-model="form.content"></el-input>
                          </el-form-item>
                          <el-form-item label="开始时间">
                            <el-date-picker
                              v-model="form.startTime"
                              type="datetime"
                              placeholder="选择开始时间"
                              @change="openSche">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item label="结束时间">
                            <el-date-picker
                              v-model="form.endTime"
                              type="datetime"
                              placeholder="选择结束时间"
                              :picker-options="{
                                disabledDate (time) {
                                  return time.getTime() < new Date(new Date(form.startTime).setHours(0, 0, 0, 0))
                                }
                              }"
                              @change="openSche">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item label="会议室" v-if="form.scheduleType == 'meeting'">
                            <el-select v-model="form.meetingRoomId">
                              <el-option v-for="(item,index) in meetingRoomList" :key="index" :label="item.meetingRoomName" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="参与人">
                            <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 0 5px;">
                              <div style="display: flex;font-size: 12px;flex-wrap: wrap;">
                                <i class="el-icon-circle-plus-outline cursor_point" @click="userSelectConfig.dialogVisible = true;" style="color: #C0C4CC;line-height: 24px;"></i>
                                <el-tag @close="handleCloseTag(index)"
                                  v-for="(item,index) in form.personData" type='plain' size="mini" :key="index" closable>
                                  {{item.name}}
                                </el-tag>
                              </div>
                            </div>
                          </el-form-item>
                          <el-form-item label="提醒时间">
                            <el-select v-model="form.teminderTypeCode">
                              <el-option v-for="(item,index) in remindSelect" :key="index" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                      </div>
                      <div v-show="form.type == 'view'" style="padding: 12px;font-size: 12px;">
                          <el-form :model="form" label-width="60px" size="mini" class="table-form">
                            <el-tag color="#b72024" size="small" style="margin-bottom: 10px;"> <span style="color: #fff;">{{ form.scheduleType == 'meeting'?'会议':'日程' }}</span></el-tag>
                            <el-form-item label="主题">
                              <div style="font-size: 12px;height: 28px;">{{ form.title }}</div>
                            </el-form-item>
                            <el-form-item label="内容">
                              <div style="font-size: 12px;height: 28px;">{{ form.content }}</div>
                            </el-form-item>
                            <el-form-item label="开始时间">
                              <div style="font-size: 12px;height: 28px;">{{ changeDay(form.startTime) }}</div>
                            </el-form-item>
                            <el-form-item label="结束时间">
                              <div style="font-size: 12px;height: 28px;">{{ changeDay(form.endTime) }}</div>
                            </el-form-item>
                            <el-form-item label="会议室" v-if="form.scheduleType == 'meeting'">
                              <div style="font-size: 12px;height: 28px;" v-if="form.meetingRoomId">{{ meetingRoomList.find(item => item.id ==form.meetingRoomId).meetingRoomName  }}</div>
                            </el-form-item>
                            <el-form-item label="参与人">
                              <div style="padding: 0 5px;">
                                <div style="display: flex;font-size: 12px;flex-wrap: wrap;">
                                  <el-tag 
                                    v-for="(item,index) in form.personData" type='info' effect="plain" size="mini" :key="index">
                                    {{item.name}}
                                  </el-tag>
                                </div>
                              </div>
                            </el-form-item>
                            <el-form-item label="提醒时间">
                              <div style="font-size: 12px;height: 28px;">{{ form.teminderTypeName }}</div>
                            </el-form-item>
                          </el-form>
                      </div>
                      <div style="text-align: right; margin: 0">
                        <el-button class="size_button_12" size="mini" v-show="form.type !== 'view'" @click="popoverVisible = false">取消</el-button>
                        <el-button class="size_button_12" size="mini" v-show="form.type == 'view'" @click="deleteCanlender">删除</el-button>
                        <el-button type="primary" class="size_button_12" size="mini" v-show="form.type == 'view'" @click="updateCanlenderStatus">编辑</el-button>
                        <el-button type="primary" class="size_button_12" size="mini"v-show="form.type !== 'view'" @click="sureCanlender">保存</el-button>
                      </div>
                      <el-button slot="reference" circle class="canlendar-option" @click="clearShow" icon="el-icon-plus"></el-button>
                  </el-popover>
                  
                  <!-- <div class="canlendar-lunar">{{ day }}</div> -->
                  <div v-show="day == item.date" style="height: 120px;overflow-y: auto;" v-for="(item,index) in scheduleList" :key="index">
                      <div class="canlendar-item" v-for="(t,i) in item.items" :key="i" @click="updateCanlender(t)">
                        <div class="canlendar-left">
                          <div v-show="i === 0">{{ item.date.slice(8,10) }}</div>
                        </div>
                        <div class="canlendar-right">
                          <div class="canlendar-content">
                          {{ t.scheduleType == 'meeting'?'会议':'日程' }} <span style="margin: 0 5px;">|</span> {{ t.title }}
                          </div>
                          <div class="canlendar-day">
                            <span>{{ changeDayTime(t.startTime).slice(10,16) }}</span> ~
                            <span>{{ changeDayTime(t.endTime).slice(10,16) }}</span>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="body-main_two">
            <div class="body-main_left">
              <!-- <div class="body-model">
                <div class="body-model_special">
                  <div style="font-weight: 500;">感谢您陪伴汉森制药<span style="color: #058ACF;font-size:20px;padding: 0 10px;font-weight: 700;">{{ entryDay }}</span>天</div>
                  <div class="body-special_avatar">
                    <el-avatar src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                    <div>
                        <div>{{ headInfo.userInfoResp.userName }} <span>{{ headInfo.userInfoResp.userCode }}</span></div>
                        <div>{{ headInfo.userInfoResp.dept }}</div>
                        <div>{{ headInfo.userInfoResp.position }}</div>
                    </div>
                  </div>
                </div>
                <div class="body-model_block">
                  <div>{{ headInfo.restDays || 0 }}</div>
                  累计调休可用(天)
                </div>
                <div class="body-model_block">
                  <div>{{ headInfo.overtimeMonth || 0  }}</div>
                  本月加班(小时)
                </div>
                <div class="body-model_block" style="margin-right: 0;">
                  <div>{{ headInfo.unCheckQuantity || 0  }}</div>
                  本月考勤异常(次)
                </div>
              </div> -->
              <div class="body-message">
                <div class="list-title">
                  <div class="list-title_bold">我的待办<span>/TODO</span></div>
                  <div class="list-title_more" @click="goFlow()">更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <div class="body-message_title">
                  <el-radio-group v-model="messageType" @change="changeRadio">
                    <el-radio-button label="待办">待办<span>{{ headInfo.todoCount }}</span></el-radio-button>
                    <el-radio-button label="已办">已办<span>{{ headInfo.doneCount }}</span></el-radio-button>
                    <el-radio-button label="待阅">待阅<span>{{ headInfo.toReadCount }}</span></el-radio-button>
                    <el-radio-button label="已阅">已阅<span>{{ headInfo.readCount }}</span></el-radio-button>
                  </el-radio-group>
                </div>
                <el-table :data="tableData" class="body-message_table" height="360" 
                  v-loading="todoLoading"
                  element-loading-text="加载中..."
                  :header-cell-style="{'border-bottom': 'none','color': '#a9b8bf','font-size': '13px','font-weight': '500',}"
                  style="width: 100%">
                  <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    class-name="message_table--status"
                    width="80">
                    <template slot-scope="scope">
                      <el-tag type="warning" v-if="scope.row.status === 20">办理中</el-tag>
                      <el-tag type="warning" v-else-if="scope.row.status === 10">草稿</el-tag>
                      <el-tag type="warning" v-else-if="scope.row.status === 35">已驳回</el-tag>
                      <el-tag type="warning" v-else-if="scope.row.status === 40">取消</el-tag>
                      <el-tag type="warning" v-else-if="scope.row.status === 45">撤销</el-tag>
                      <el-tag type="warning" v-else-if="scope.row.status === 60">异常</el-tag>
                      <el-tag type="success" v-else-if="scope.row.status === 50">审核通过</el-tag>
                      <el-tag type="success" v-else>已处理</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="flowName"
                    label="流程标题"
                    :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column
                    prop="typeName"
                    label="流程类型"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="processNo"
                    label="单据编号"
                    align="center"
                    width="130">
                  </el-table-column>
                  <el-table-column
                    prop="applyUserName"
                    label="发起人"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="applyTime"
                    label="发起时间"
                    :formatter="changeTime"
                    align="center"
                    width="180">
                  </el-table-column>
                </el-table>
                 <div class="list-title">
                  <div class="list-title_bold">常用应用<span>/PROCESS</span></div>
                  <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <el-row :gutter="20" style="padding: 0 15px;">
                  <el-col class="apply-list" :span="6" v-for="(item,index) in applyList" :key="index">
                    <div class="apply-item" @click="goApp(item)">
                      <img style="height: 40px;margin-left: 20px;margin-top: 15px;" :src="item.systemIcon" fit="cover"></img>
                      <div>{{ item.systemName }}</div>
                    </div>
                  </el-col>
                </el-row>
                <div class="list-title">
                  <div class="list-title_bold">常用流程<span>/PROCESS</span></div>
                  <div class="list-title_more">更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <el-row :gutter="20">
                  <el-col :span="4" style="margin-left: 20px;margin-bottom: 20px;" v-for="(item,index) in flowList" :key="index">
                    <el-card style="width: 128px;height: 174px;text-align: center;" shadow="never" class="card-item">
                      <svg v-if="item.picUrl&&item.picUrl.startsWith('#hs-icon')"  class="hs-icon" style="font-size:50px;margin-top: 12px;" aria-hidden="true">
                          <use :xlink:href="item.picUrl"></use>
                      </svg>
                      <el-avatar v-else shape="square" fit="fill" :size="70" :src="global.BASE_URL_2971 + item.picUrl"></el-avatar>
                      <el-tooltip class="item" effect="dark" :content="item.flowName" placement="top-start">
                        <div style="font-size: 12px;">{{ item.flowName | filterTitle }}</div>
                      </el-tooltip>
                      <el-button type="primary" @click="goAdd(item)" style="position: absolute;bottom: 10px;left: 25px;font-size: 12px;" size="mini" >发起流程</el-button>
                    </el-card>
                  </el-col>
                </el-row>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <user-select @confirm="userSelectConfirm" :config="userSelectConfig"></user-select>
  </el-container>
</template>

<script>
import LunarCanlendar from './components/LunarCanlendar.vue';
import UserSelect from '@/components/UserSelect.vue'
import { data } from 'jquery';
import { Solar } from 'lunar-javascript'
import moment from 'moment'
export default {
  name: 'mian',
  components: {
    LunarCanlendar,
    UserSelect,
  },
  data() {
    return {
      moment,
      headInfo: {
        userInfoResp:{}
      },
      noticeBanner: [],
      news: [
        // {
        //   flag: 'new',
        //   title: '四季度业务评比竟赛收官喜报',
        //   time: '2025-01-20'
        // },
        // {
        //   title: '三季度业务评比竟赛收官喜报',
        //   time: '2025-01-15'
        // },
        // {
        //   title: '二季度业务评比竟赛收官喜报',
        //   time: '2025-01-05'
        // },
        // {
        //   title: '一季度业务评比竟赛收官喜报',
        //   time: '2025-01-01'
        // },
      ],
      notices: [
        // {
        //   flag: 'new',
        //   title: '关于2024年国庆节放假安排的通知',
        //   time: '2024-09-20'
        // },
        // {
        //   title: '关于2024年端午节放假安排的通知',
        //   time: '2025-05-01'
        // },
      ],
      picUrls: [
        {
          src:'https://cdnjs0001.ausnutria.com/file/updata/41bec8be74f145668c4a890e288a58b8.jpg',
        },
        {
          src:'https://aus-auportal.oss-cn-shanghai.aliyuncs.com/file/updata/a58e5a667af548b5b4e39fe5f25780bc.png',
        },
      ],
      messageType: '待办',
      todoLoading: false,
      tableData: [
        {
          flow: '赵某某办公用品领用申请',
          orderNo: '20250120004491',
          day: '2025-01-20'
        },
        {
          flow: '赵某某_MRM发起的仓位新增申请',
          orderNo: 'CW20250117000002',
          day: '2025-01-17'
        },
        {
          flow: 'MB2025010015赵湘萍码包申请',
          orderNo: 'MB2025010015',
          day: '2025-01-17'
        },
        {
          flow: 'MB2025010007赵湘萍码包申请',
          orderNo: 'MB2025010007',
          day: '2025-01-17'
        },
        {
          flow: 'MRM发起的活动主题申请',
          orderNo: 'MAZT20250116000',
          day: '2025-01-16'
        },
        {
          flow: 'MRM发起的活动规划申请',
          orderNo: 'MRGH2025011600',
          day: '2025-01-16'
        },
      ],
      day: '',
      popoverVisible: false,
      scheduleList: [],
      originalList: [],
      meetingRoomList: [],
      form: {
        scheduleType: 'schedule',
        personData: [],
      },
      remindSelect: [
        {
          label: '准时',
          value: '0'
        },
        {
          label: '五分钟前',
          value: '5'
        },
        {
          label: '十五分钟',
          value: 'FTM'
        },
        {
          label: '三十分钟',
          value: 'HalfHour'
        },
        {
          label: '一小时',
          value: 'AnHour'
        },
        {
          label: '两小时前',
          value: '120'
        },
        {
          label: '一天前',
          value: 'OneDay'
        },
      ],
      userSelectConfig: {
        dialogVisible: false
      },
      flowList: [],
      applyList: [
        {
          name:'HR',
        },
        {
          name:'ERP',
        },
        {
          name:'OA',
        },
        {
          name:'流向系统',
        },
        {
          name:'访客系统',
        },
        {
          name:'培训系统',
        },
        {
          name:'车辆应用',
        },
        {
          name:'提案系统',
        },
      ]
    }
  },
  computed: {
    entryDay() {
      let newDay = new Date().getTime()
      let entry = this.headInfo.userInfoResp?new Date(this.headInfo.userInfoResp.serviceDate).getTime():new Date().getTime()
      console.log(entry,'computed')
      return Math.floor((newDay - entry) / (24 * 60 * 60 * 1000))
    },
  },
  filters: {
    filterNew: function(value) {
      if (!value) return;
      if (value.length <= 18) return value;
      let val = value.slice(0, 18) + '...'
      return val
    },
    filterTitle: function(value) {
      if (!value) return;
      if (value.length <= 10) return value;
      let val = value.slice(0, 10) + '...'
      return val
    },
  },
  created() {
    console.log('created')
    this.getHeadInfo()
    this.getNew()
    this.getNotice()
    this.getMenus()
    this.getApp()
    this.myTask('/msi/flow/engine/process/myTasks')
    this.day = moment(new Date()).format('YYYY-MM-DD')
    this.initData(moment(new Date()).format('YYYY-MM-DD'))
  },
  methods: {
    updateCanlenderStatus(){
      console.log(this.form,'form')
      this.$set(this.form,'type','edit')
    },
    updateCanlender(t){
      let data = this.originalList.find(item => item.id == t.id)
      console.log(data,'ddds')
      this.form = data
      let formData = new FormData()
      formData.append('scheduleId',data.id)
      this.$axios.post(this.global.BASE_URL_2971+'/msi/oa/schedule/findAllScheduleStaff',formData)
        .then(res =>{
          if(res.data.code === '0000'){
            console.log(res)
            let personData = res.data.data.map(item => {
              item.name = item.userName
              item.id = item.userInfoId
              return item
            })
            this.$set(this.form,'personData',personData)
            this.$set(this.form,'type','view')
            this.openSche()
          }
        })
    },
    deleteCanlender(){
      this.$confirm("确认删除？","提示",{
        confirmButtonText:"确定",
        cancelButtonText:"取消",
        type:"warning",
        center:true,
      })
      .then(() => {
        let formData = new FormData()
        formData.append('id',this.form.id)
        this.$axios.post(this.global.BASE_URL_2971+'/msi/oa/schedule/deleteSchedule',formData)
          .then(res =>{
          if(res.data.code === '0000'){
            this.$message('删除成功')
            this.form = {
              scheduleType: 'schedule',
              personData: [],
            }
            this.popoverVisible = false
            this.initData(moment(this.day).format('YYYY-MM-DD'))
          }
        })
      })
      .catch((error) => {
        console.log(error);
      });
    },
    sureCanlender(){
      this.form.personData.push({id:JSON.parse(localStorage.getItem('user')).userInfoId})
      let newArr = this.form.personData.map(item =>item.id)
      let data = {
        data:{
          ...this.form,
          startTime: moment(this.form.startTime).format('yyyy-MM-DD HH:mm:ss'),
          endTime: moment(this.form.endTime).format('yyyy-MM-DD HH:mm:ss'),
          teminderTypeName: this.remindSelect.find(item => item.value === this.form.teminderTypeCode).label,
          staffIds: [...new Set(newArr)]
        }
      }
      let url = ''
      if(this.form.id){
        url = this.global.BASE_URL_2971+'/msi/oa/schedule/updateSchedule'
      }else{
        url = this.global.BASE_URL_2971+'/msi/oa/schedule/insertSchedule'
      }
      this.$axios.post(url,data)
        .then(res =>{
          if(res.data.code === '0000'){
            this.$message('新增日程成功')
            this.form = {
              scheduleType: 'schedule',
              personData: [],
            }
            this.popoverVisible = false
            this.initData(moment(this.day).format('YYYY-MM-DD'))
          }
        })
    },
    clearShow(){
      this.form = {
        scheduleType: 'schedule',
        personData: [],
      }
    },
    showPopover(){
      if(this.meetingRoomList.length === 0){
        this.getMeeting()
      }
    },
    openSche(){
      this.popoverVisible = true
    },
    getMeeting(){
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/oa/meeting/room/findMeetingRoom', {
          data:{status:50,meetingRoomStatus: '50'},pageIndex:0,pageSize:999
      }).then(res => {
        if (res.data.status === 'Y') {
          this.meetingRoomList = res.data.data
          console.log(this.meetingRoomList,'this.meetingRoomList')
        }
      })
    },
    initData (month) {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/oa/schedule/findAllScheduleNew', {
       data:{month:month.slice(0,7)}
      }).then(res => {
        if (res.data.status === 'Y') {
          this.scheduleList = []
          this.originalList =  res.data.data
          this.scheduleList = this.splitDataByDay(res.data.data);
          console.log(7878,this.scheduleList)
        }
      })
    },
    // 重置日期格式
    splitDataByDay(originalData) {
      const resultMap = new Map(); // 使用 Map 按天存储数据

      originalData.forEach(item => {
        const startDate = new Date(item.startTime);
        const endDate = new Date(item.endTime);

        // 如果开始和结束是同一天
        if (isSameDay(startDate, endDate)) {
          const dateKey = getDateKey(startDate);
          addToMap(resultMap, dateKey, item);
        } else {
          // 跨天的情况，需要拆分
          let currentDate = new Date(startDate);
          
          while (currentDate <= endDate) {
            const dateKey = getDateKey(currentDate);
            const isFirstDay = currentDate.getTime() === startDate.getTime();
            const isLastDay = isSameDay(currentDate, endDate);

            // 创建当天的部分数据
            const dayItem = {
              ...item,
              startTime: isFirstDay ? item.startTime : getDayStart(currentDate).getTime(),
              endTime: isLastDay ? item.endTime : getDayEnd(currentDate).getTime(),
              isPartial: !(isFirstDay && isLastDay) // 标记是否为部分数据
            };

            addToMap(resultMap, dateKey, dayItem);

            // 移动到下一天
            currentDate.setDate(currentDate.getDate() + 1);
            currentDate = getDayStart(currentDate); // 重置为下一天的开始
          }
        }
      });

      // 将 Map 转换为排序后的数组
      return Array.from(resultMap.entries())
        .sort((a, b) => a[0] - b[0])
        .map(([date, items]) => ({
          date: date,
          items: items.sort((a, b) => a.startTime - b.startTime)
        }));

      // 辅助函数：判断两个日期是否是同一天
      function isSameDay(date1, date2) {
        return getDateKey(date1) === getDateKey(date2);;
      }

      // 辅助函数：获取日期的键（当天0点的时间戳）
      function getDateKey(date) {
        return moment(date).format('YYYY-MM-DD')
      }

      // 辅助函数：获取当天的开始时间（0点）
      function getDayStart(date) {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);
        return newDate;
      }

      // 辅助函数：获取当天的结束时间（23:59:59.999）
      function getDayEnd(date) {
        const newDate = new Date(date);
        newDate.setHours(23, 59, 59, 999);
        return newDate;
      }

      // 辅助函数：将数据添加到 Map 中
      function addToMap(map, key, item) {
        item.startTime = changeTimeRow(item.startTime)
        item.endTime = changeTimeRow(item.endTime)
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(item);
      }

      // 辅助函数：将Map中的数据格式化
      function changeTimeRow(data) {
        return moment(data).format('YYYY-MM-DD HH:mm')  
      }
    },
    getMenus(){
        this.$axios.post(this.global.BASE_URL+'/msi/flow/engine/process/findCommonProcess',
          {data:{},pageIndex:0,pageSize:10})
          .then(res => {
              if(res.data.code === '0000'){
                  this.flowList = res.data.data
              }
          })
    },
    goApp(item){
      window.open(item.systemUrl,'_blank');
    },
    getApp(){
        this.$axios.post(this.global.BASE_URL+'/msi/base/info/system/myLikeSystem',
          {data:{},pageIndex:0,pageSize:10})
          .then(res => {
              if(res.data.code === '0000'){
                  this.applyList = res.data.data.splice(0,8)
              }
          })
    },
    goAdd(item){
      window.open(this.global.BASE_URL_2971+'/#/portal'+item.flowCode,'_blank');
      // window.open('http://localhost:3000/#/portal'+item.flowCode,'_blank');
    },
    changeTime (row, column) {
      let date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    goFlow(){
      this.$router.push({name:"flow"})
    },
    getHeadInfo() {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/flow/engine/task/findTaskCount', { data: {} })
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.headInfo = res.data.data
          }
        })
    },
    getNew() {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/article/findWebArticleRealTime', { data: {} })
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.news = res.data.data.news
            this.picUrls = res.data.data.focus
            this.notices = res.data.data.notice
          }
        })
    },
    getNotice() {
      let data = {
        asp: JSON.parse(localStorage.getItem('user')).asp,
        data: {
          location: 'homePage',
          siteCode: 'W',
          status: '50'
        },
        pageIndex: 0,
        pageSize: 10,
      }
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/cms/web/adpic/findWebAdpic', data)
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.noticeBanner = res.data.data
          }
        })
    },
    newList(type) {
      const route = this.$router.resolve({ path: `/newsList/${type}`  });
      window.open(route.href, '_blank');
    },
    newDetail(item) {
      // this.$router.push({ name:'news', path:`/news/${item.articleId}` })
      const route = this.$router.resolve({ path: `/news/${item.articleId}`  });
      window.open(route.href, '_blank');
    },
    changeRadio(val) {
      console.log(val, 'cal')
      if (val === '待办') {
        this.myTask('/msi/flow/engine/process/myTasks')
      } else if (val === '已办') {
        this.myTask('/msi/flow/engine/process/myCompletedTasks')
      } else if (val === '待阅') {
        this.myTask('/msi/flow/engine/process/findFlowMsg',{messageStatus:20})
      } else if (val === '已阅') {
        this.myTask('/msi/flow/engine/process/findFlowMsg',{messageStatus:50})
      }
    },
    myTask(url,params) {
      this.todoLoading = true
      let data = {
        asp: JSON.parse(localStorage.getItem('user')).asp,
        data: {
          ...params
        },
        pageIndex: 0,
        pageSize: 6 ,
      }
      this.$axios.post(this.global.BASE_URL_2971 + url, data)
        .then(res => {
          if (res.data.code === '0000') {
            this.tableData = res.data.data.map(item => {
              if(params){
                item.applyUserName = item.senderName
                item.applyTime = item.modifyTime
              }
              return item
            })
          }
        })
        .finally(() => {
          this.todoLoading = false
        })
    },
    changeDay(data) {
      return moment(data).format('YYYY-MM-DD')  
    },
    changeDayTime(data){
      if(data){
        let time = new Date(data)
        return moment(time).format('YYYY-MM-DD HH:mm:ss')
      }else{
        return ''
      }
    },
    userSelectConfirm(data){
      console.log(data,'data')
      data.forEach((item, index)=>{
        this.form.personData.push({name:item.nameCn,id:item.id})
      })
      this.openSche()
    },
    handleCloseTag(index) {
      this.form.personData.splice(index,1)
    },
    clickOne(data) {
      // let solar = Solar.fromDate(new Date(data.day))
      // let lunar = solar.getLunar().toFullString();
      // this.day = (lunar.split('日')[0].slice(5) + '日').replace(/\([^)]+\)(?=月)|\([^)]+\)(?=日)/g, "")
      this.day = data.day
      // console.log('one',lunar, this.day)
      this.initData(data.day)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-radio-button__inner {
  margin: 6px 20px !important;
  padding: 2px 0 !important;
  border: none !important;
  color: #83808F;
}
/deep/ .el-radio-button__inner:hover {
  color:#bb0009;
}
.is-active /deep/ .el-radio-button__inner{
  background-color: #fff !important;
  box-shadow: none !important;
  color:#bb0009;
  border-radius: 0px;
  border-bottom: 1px solid#bb0009 !important;
}
.is-active /deep/ .el-radio-button__inner:hover{
  color:#bb0009;
  border-radius: 0px;
  // border-bottom: 2px solid#bb0009 !important;
}
/deep/ .el-tag--plain {
  background-color: transparent;
  border: none !important;
  height: 24px !important;
  line-height: 24px !important;
}
.body-container {
  font-family: "-apple-system",BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB",STHeitiSC,Helvetica,"Helvetica Neue","Microsoft YaHei",Tahoma;
  font-size: 12px;
  display: block;
  padding-bottom: 16px;

  .body-main {
    padding: 0px;

    .body-header {
      margin-bottom: 10px;

      /deep/ .el-carousel__arrow {
        display: none;
      }
      /deep/ .el-carousel__indicators {
        display: none;
      }
    }

    .body-main_center {
      display: flex;
      min-height: calc(100vh - 162px);
      width: 1210px;

      .body-main_one {
        width: 420px;
        margin: 0 auto;
        min-height: 550px;
        border-radius: 12px;

        .list-content {
          background-color: #fff;
          padding: 15px;
          
          .list-body {
            min-height: 138px;
            font-size: 14px;

            .list-item {
              display: flex;
              -webkit-box-pack: justify;
              -ms-flex-pack: justify;
              justify-content: space-between;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              font-size: 14px;
              padding: 5px 0 5px;
              cursor: pointer;
              border-bottom: 0.5px solid #eaeaea;
              height: 30px;
              line-height: 30px;

              .el-tag {
                padding: 4px;
                background:#bb0009;
                border-radius: 4px;
                color: #fff;
                font-size: 10px;
                line-height: 10px;
                height: 20px;
              }

              div:last-child {
                line-height: 14px;
                text-align: right;
                color: #bebebe;
                -ms-flex-negative: 0;
                flex-shrink: 0;
              }
            }

            

            .list-item_canlendar {
              background-color: #fff;
              border-radius: 16px;
              position: relative;
              height:487px;

              .canlendar-option {
                height: 39px;
                background-color: #F0F2F5;
                text-align: center;
                position: absolute;
                right: 20px;
                bottom: 0px;
              }

              .canlendar-lunar {
                margin-left: 32px;
                font-size: 14px;
                line-height: 18px;
                color: #59575f;
              }

              .canlendar-item {
                display: flex;
                margin-bottom: 10px;

                .canlendar-left {
                  margin-right: 20px;
                  margin-left: 30px;
                  font-size: 14px;
                  font-weight: 500;
                  width: 20px;
                }

                .canlendar-right {
                  font-size: 12px;
                  line-height: 1.5;

                  .canlendar-day {
                    color: #999;
                  }
                }
              }
            }
          }
        }

        .list-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          .list-title_bold {
            font-size: 22px;
            color: #505050;
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            display: flex;

            span {
              color: #A3A3A3;
              font-size: 12px;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-align: end;
              -ms-flex-align: end;
              align-items: flex-end;
              margin-left: 2px;
              line-height: 24px;
            }
          }

          .list-title_more {
            color: #505050;
            cursor: pointer;
            line-height: 30px;
          }

          .list-title_more:hover {
            color:#bb0009;
          }
        }
      }

      .body-main_two {
        margin-left: 20px;
        width: 755px;
        margin: 0 auto;
        display: flex;

        .body-main_left {
          margin-right: 35px;

          .body-model {
            display: flex;
            width: 755px;
            margin-bottom: 16px;

            .body-model_special {
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              cursor: unset;
              padding: 16px;
              -webkit-box-flex: 1;
              -ms-flex: 1;
              flex: 1;
              background: linear-gradient(0deg, #fff, #fff),radial-gradient(171.35% 317.19% at 35.24% -44.79%, #e3fdf5 0%, #ffe6fa 100%);
              -webkit-box-orient: vertical;
              -webkit-box-direction: normal;
              flex-direction: column;
              -webkit-box-pack: justify;
              justify-content: space-between;
              border-radius: 12px;
              margin-right: 16px;

              .body-special_avatar {
                display: flex;
                margin-top: 5px;

                div {
                  margin-left: 5px;
                  color: #a9b8bf;
                }
              }
            }

            .body-model_block {
              display: flex;
              -webkit-box-orient: vertical;
              -webkit-box-direction: normal;
              flex-direction: column;
              -webkit-box-pack: center;
              justify-content: center;
              width: 154px;
              height: 112px;
              background: linear-gradient(69.85deg, #deedff 1.87%, #f7f3ef 99.3%);
              box-shadow: 1px 0px 5px rgba(0,0,0,0.05);
              border-radius: 12px;
              margin-right: 16px;
              cursor: pointer;
              text-align: center;

              div {
                color: #058ACF;
                font-size:30px;
                font-weight: 700;
              }
            }
          }

          .body-message {
            background-color: #fff;
            width: 755px;
            padding: 15px;
            border-radius: 12px;
            min-height: 350px;

            .card-item {
              text-align: center;
              // background-color: #EBEEF5;
              position: relative;

              /deep/ .el-card__body {
                padding: 0 5px !important;
              }

              .el-avatar{
                margin-top: 20px;
                /deep/  img {
                  width: 70px !important;
                }
              }

              div{
                font-size: 12px;
              }
            }

            .apply-list {
              padding: 10px;

              .apply-item {
                height: 70px;
                line-height: 70px;
                border: 1px solid #eaeaea;
                display: flex;

                div {
                  margin-left: 20px;
                }
              }
            }

            .list-title {
              display: flex;
              justify-content: space-between;
              margin-right: 20px;
              margin-bottom: 10px;

              .list-title_bold {
                font-size: 22px;
                color: #505050;
                font-weight: bold;
                height: 30px;
                line-height: 30px;
                display: flex;

                span {
                  color: #A3A3A3;
                  font-size: 12px;
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-align: end;
                  -ms-flex-align: end;
                  align-items: flex-end;
                  margin-left: 2px;
                  line-height: 24px;
                }
              }

              .list-title_more {
                color: #505050;
                cursor: pointer;
                line-height: 30px;
              }

              .list-title_more:hover {
                color:#bb0009;
              }
            }

            .body-message_title {
              display: flex;
              justify-content: space-between;

              .el-radio-group {
                border-radius: 100px;

                /deep/ .el-radio-button__inner {
                  margin: 6px 20px !important;
                  padding: 2px 0 !important;
                  border: none !important;
                  color: #83808F;
                }
                /deep/ .el-radio-button__inner:hover {
                  color:#bb0009;
                }
                .is-active /deep/ .el-radio-button__inner{
                  background-color: #fff !important;
                  box-shadow: none !important;
                  color:#bb0009;
                  border-radius: 0px;
                  border-bottom: 1px solid#bb0009 !important;
                }
                .is-active /deep/ .el-radio-button__inner:hover{
                  color:#bb0009;
                  border-radius: 0px;
                  // border-bottom: 2px solid#bb0009 !important;
                }

                span {
                  margin-left: 4px;
                }
              }

              .el-icon-top-right {
                height: 28px;
                line-height: 28px;
                width: 28px;
                text-align: center;
                font-size: 24px;
                background: #f0f2f5;
                border-radius: 8px;
              }

            }

            .body-message_table {
              margin-top: 12px;
              
              /deep/ .el-tag {
                padding: 0 5px;
                line-height: 24px;
                height: 24px;
              }

            /deep/ .message_table--status {
                border-bottom: none !important;
                
              }
            }

            .el-table::before {
              height: 0;
            }

          }
        }
      }

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/main/index-new.vue